import gql from "graphql-tag";
//import { fetchMethod } from "../../FetchMethod";
export const login = gql`
  mutation UsersDataLogin($credentials: JSON) {
    UsersdataLogin(credentials: $credentials)
  }
`;

export const UserIdMatch = id => {
  return `query{
  allUsersdata(where: {email: ${id}}) {
    Usersdata {
      id
    }
  }
}`;
};
export const ChangePassword = gql`
  mutation UsersdataSetPassword($id: JSON, $newPassword: String) {
    UsersdataSetPassword(id: $id, newPassword: $newPassword)
  }
`;

export const ValidUser = gql`
  query allUsersdata($where: JSON) {
    allUsersdata(where: $where) {
      Usersdata {
        id
      }
    }
  }
`;

export const UserIdRole = id => {
  return `query{
allUsersdata(where:{id:${id}}){
Usersdata{
role
customerid
}}
}`;
};
